module.exports = __webpack_public_path__ + "img/1.ab062c8e.png";